import { render } from "./LocalSwitcher.vue?vue&type=template&id=035d3c2e"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LocalSwitcher.vue?vue&type=style&index=0&id=035d3c2e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__